import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ResetTaskProgressBar from "./ResetTaskProgressBar";
import ResetTasksFlow, { RESET_TASK_PROGRESS_STEPS } from "./ResetTasksFlow";
import "./ResetTasksFlow.css";

function TeacherResetTasksModal({
  show,
  handleClose,
  prefill = null,
  onWorkflowComplete = null
}) {
  const [progressStep, setProgressStep] = useState(0);

  useEffect(() => {
    if (show) {
      setProgressStep(0);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      className="teacher-reset-modal"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Reset Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ResetTaskProgressBar
          steps={RESET_TASK_PROGRESS_STEPS}
          currentStep={progressStep}
        />
        {show && (
          <ResetTasksFlow
            teacherMode={true}
            modalMode={true}
            initialSearchQuery=""
            onSearchQueryChange={undefined}
            onProgressStepChange={setProgressStep}
            prefill={prefill}
            onWorkflowComplete={onWorkflowComplete}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default TeacherResetTasksModal;
